var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarRegular = function SvgStarRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.973 4.75c.273 0 .492.164.601.383l1.887 3.855 4.184.63c.246.027.437.218.52.437a.643.643 0 0 1-.165.683l-3.035 3.008.71 4.238a.66.66 0 0 1-.245.657.737.737 0 0 1-.711.054l-3.746-2.023-3.746 2.023c-.22.11-.465.082-.684-.054-.191-.137-.3-.41-.273-.657l.738-4.238-3.035-3.008a.643.643 0 0 1-.164-.683c.082-.22.273-.41.52-.438l4.183-.629 1.886-3.855c.11-.219.329-.383.575-.383Zm0 2.16L10.55 9.89c-.11.192-.274.329-.492.356l-3.254.465 2.351 2.324a.705.705 0 0 1 .192.602L8.8 16.89l2.87-1.532a.644.644 0 0 1 .63 0l2.87 1.532-.546-3.254c-.055-.219.027-.438.191-.602l2.325-2.324-3.227-.465a.616.616 0 0 1-.492-.355l-1.45-2.98Z"
  })));
};

export default SvgStarRegular;